/*jshint esversion: 11 */

import "./style.css";
import errorPage from "./component/error-page/error-page";
import { apiUrl, localforage, taskId } from "./config";
import routes from "./router/router";
import checkIfAdBlockEnabled from "./lib/AdDetect";
import i18n from "./i18n";
import { resolveModelBindings } from "./lib/modelParser";

/* Get configuration */

if (apiUrl) {
    fetch(apiUrl, {
        method: 'GET',
        headers: {
            "Accept": "application/json"
        }
    })
        .then((response) => {
            if (response.status === 200) return response.json();

            return response;
        })

        /* Process configuration */
        .then((response) => {

            if (Object.keys(response).length > 0) {

                const { config, model, wedat } = response;

                document.title = config?.appTitle ?? "myClaim";

                if (config?.adblock)
                    checkIfAdBlockEnabled(config.adblock)

                localforage
                    .getItem(taskId)
                    .then((result) => {
                        let saveOrUpdateData = {};

                        if (!result) {
                            const resolvedWedat = resolveModelBindings(wedat, model);

                            /* Store new pyload */
                            saveOrUpdateData = { config, model, wedat: resolvedWedat };
                        } else {
                            const resolvedWedat = resolveModelBindings(wedat, result.model);

                            /* Restore payload from disc and update configuration */
                            saveOrUpdateData = {
                                config,
                                model: result.model,
                                status: result?.status,
                                wedat: result?.status !== undefined ? result.wedat : resolvedWedat
                            };

                        }

                        /* Store process configuration and data in IndexedDB. */
                        return localforage.setItem(taskId, saveOrUpdateData);
                    })
                    .then((res) => {

                        /* Prepare routing */
                        routes.views = res.wedat.views;

                        /* Then Start! */
                        routes.go();
                    });
            } else {

                errorPage(i18n(response.status));

            }
        })
        .catch(() => errorPage(i18n("default")));

} else {
    errorPage(i18n("invalid-url"));
}
